import { MessageSquare } from "lucide-react"
import { cn } from "@/lib/utils"

interface ConciergeTriggerProps {
  hasNotification: boolean
  priority?: string
  isPanelOpen: boolean
  onClick: () => void
}

export function ConciergeTrigger({ hasNotification, priority, isPanelOpen, onClick }: ConciergeTriggerProps) {
  const isHighOrMedium = priority === "high" || priority === "medium"

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "fixed z-[100]",
        "h-14 w-14 rounded-full",
        "bg-primary text-primary-foreground",
        "flex items-center justify-center",
        "shadow-lg transition-all duration-200",
        "hover:scale-105 hover:shadow-xl hover:bg-primary/90",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "bottom-6 right-6 max-md:bottom-4 max-md:right-4 max-md:h-12 max-md:w-12",
        isPanelOpen && "opacity-0 pointer-events-none scale-75",
      )}
      aria-label="Open FRAME Concierge"
    >
      <MessageSquare className="h-6 w-6" />

      {/* Pulse ring for medium/high priority */}
      {hasNotification && isHighOrMedium && (
        <span className="absolute inset-0 rounded-full animate-ping ring-2 ring-primary/30 pointer-events-none" />
      )}

      {/* Notification dot */}
      {hasNotification && (
        <span
          className={cn(
            "absolute top-0 right-0",
            "h-3 w-3 rounded-full",
            "bg-destructive border-2 border-background",
          )}
        />
      )}
    </button>
  )
}
